<template>
    <div class="foreign-device-option">
        <div class="foreign-device-option__row">
            <b-form-checkbox :checked="value" @input="$emit('input', $event)">Чужое устройство</b-form-checkbox>
            <button type="button" class="foreign-device-option__help" aria-label="Что означает «Чужое устройство»" :aria-expanded="showHelp ? 'true' : 'false'" :aria-controls="helpId" @click="showHelp = !showHelp">?</button>
        </div>
        <p v-if="showHelp" :id="helpId" class="foreign-device-option__description">Отметьте, если пользуетесь чужим или общим компьютером либо телефоном. Закончив работу, нажмите «Выйти».</p>
    </div>
</template>
<script>
export default {
    props: {value: {type: Boolean, default: false}},
    data() { return {showHelp: false}; },
    computed: {helpId() { return 'foreign-device-help-' + this._uid; }}
};
</script>
<style scoped>
.foreign-device-option { margin-bottom: 16px; }
.foreign-device-option__row { display: flex; align-items: center; gap: 8px; }
.foreign-device-option__help { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 28px; width: 28px; height: 28px; padding: 0; border: 1px solid #c8d8e5; border-radius: 50%; background: #f3f7fb; color: #486a85; font-size: 14px; font-weight: 600; line-height: 1; cursor: pointer; }
.foreign-device-option__help:hover { background: #e8f0f7; border-color: #8caec8; }
.foreign-device-option__help:focus-visible { outline: 2px solid #2875b6; outline-offset: 2px; }
.foreign-device-option__description { margin: 8px 0 0; padding: 10px 12px; border: 1px solid #dce5ec; border-radius: 8px; background: #f4f8fb; color: #486175; font-size: .85rem; line-height: 1.5; }
</style>
